// İSG uzmanı portalı — bilinmeyen rota (404, owner review B2 item 5, 2026-09-28).
//
// Eskiden HER bilinmeyen URL sessizce Panel'e yönlendiriliyordu (`router.tsx`'in kök `path: '*'`
// eşleşmesi) — kullanıcı bir hata ile karşılaşmadığını sanıp aynı yanlış bağlantıya (yer imi,
// eski link) tekrar tekrar dönebiliyordu. Bu sayfa artık `router.tsx`'te `AppLayout`'un (giriş
// gerektiren kabuk) ÇOCUKLARININ SONUNCUSU — `RequireAuth` üstte KALDIĞINDAN oturum YOKSA bu
// sayfa hiç render edilmez, kullanıcı her zamanki gibi login'e yönlenir (davranış DEĞİŞMEDİ);
// oturum VARSA kabuğun İÇİNDE (header + nav ile) render edilir (görev tarifi "inside the shell
// when logged in"). Köşe çizgisiz (`Breadcrumb` YOK) — bilinmeyen bir konumun tanımlı bir
// ebeveyni yoktur, sahte bir "Panel / ???" kırıntısı üretmez. Diğer erişim-kapısı durum
// sayfalarıyla (`PermitsGate.tsx` vb.) AYNI görsel iskelet (ortalanmış `Card`, ikon, başlık, tek
// satır, geri düğmesi) — yeni bir desen İCAT EDİLMEDİ.

import { Button, Card, CardContent } from '@isgportal/shared';
import { FileQuestion } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-lg">
      <Card>
        <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
          <FileQuestion className="h-10 w-10 text-muted" aria-hidden="true" />
          <div className="flex flex-col gap-1.5">
            <h1 className="text-xl font-semibold text-fg">{t('notFound.title')}</h1>
            <p className="text-sm text-muted">{t('notFound.body')}</p>
          </div>
          {/* owner review B4-8 — bu sayfanın TEK aksiyonu; `secondary` (dolu gri) burada YALNIZ
              başına gösterge KAYBEDİYORDU. Carbon'un boş/hata durumu konvansiyonu TEK CTA için
              `primary`dir. */}
          <Button asChild variant="primary">
            <Link to="/">{t('notFound.back')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
